<template>
    <div class="stamp">
        <Loading v-show="loading"></Loading>
        <div class="content" v-show="!loading">
            <div class="container">
            <article class="article-item box">
              <div class="article-inside">
                <button id="w"><img src="../assets/line/line_aw.png"></button>
              </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_atui"><img src="../assets/stamp/atui.png"></button>
                <audio ref="audioElm_atui" src="../sound/atui.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_arigato"><img src="../assets/stamp/arigatou.png"></button>
                <audio ref="audioElm_arigato" src="../sound/arigato.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_iine"><img src="../assets/stamp/iine.png"></button>
                <audio ref="audioElm_iine" src="../sound/iine.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_iiyo"><img src="../assets/stamp/iiyo.png"></button>
                <audio ref="audioElm_iiyo" src="../sound/iiyo.mp3"></audio><br>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_itai"><img src="../assets/stamp/itai.png"></button>
                <audio ref="audioElm_itai" src="../sound/itai.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_ittekimasu"><img src="../assets/stamp/ittekimasu.png"></button>
                <audio ref="audioElm_ittekimasu" src="../sound/ittekimasu.mp3"></audio><br>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_itterassyai"><img src="../assets/stamp/itterassyai.png"></button>
                <audio ref="audioElm_itterassyai" src="../sound/itterassyai.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_ureshii"><img src="../assets/stamp2/ureshii.png"></button>
                <audio ref="audioElm_ureshii" src="../sound/ureshii.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_un"><img src="../assets/stamp2/un.png"></button>
                <audio ref="audioElm_un" src="../sound/un.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_oishiine"><img src="../assets/stamp/oishiine.png"></button>
                <audio ref="audioElm_oishiine" src="../sound/oishiine.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_okaeri"><img src="../assets/stamp/okaeri.png"></button>
                <audio ref="audioElm_okaeri" src="../sound/okaeri.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_okikunatta"><img src="../assets/stamp/okikunatta.png"></button>
                <audio ref="audioElm_okikunatta" src="../sound/okikunatta.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_otukare"><img src="../assets/stamp/otukare.png"></button>
                <audio ref="audioElm_otukare" src="../sound/otukaresama.mp3"></audio><br>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_onakaitai"><img src="../assets/stamp/onakaitai.png"></button>
                <audio ref="audioElm_onakaitai" src="../sound/onakaitai.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_onakaippai"><img src="../assets/stamp2/onakaippai.png"></button>
                <audio ref="audioElm_onakaippai" src="../sound/onakaippai.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_onakasuita"><img src="../assets/stamp/onakasuita.png"></button>
                <audio ref="audioElm_onakasuita" src="../sound/onakasuita.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_onegai"><img src="../assets/stamp2/onegai.png"></button>
                <audio ref="audioElm_onegai" src="../sound/onegai.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_ohayo"><img src="../assets/stamp/ohayou.png"></button>
                <audio ref="audioElm_ohayo" src="../sound/ohayo.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_omedeto"><img src="../assets/stamp/omedeto.png"></button>
                <audio ref="audioElm_omedeto" src="../sound/omedeto.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_oyasumi"><img src="../assets/stamp/oyasumi.png"></button>
                <audio ref="audioElm_oyasumi" src="../sound/oyasuminasai.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button id="w"><img src="../assets/line/line_kaw.png"></button>
              </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_ganbatte"><img src="../assets/stamp/ganbatte.png"></button>
                <audio ref="audioElm_ganbatte" src="../sound/ganbatte.mp3"></audio><br>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_ganbaru"><img src="../assets/stamp/ganbaru.png"></button>
                <audio ref="audioElm_ganbaru" src="../sound/ganbaru.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_kiwotukete"><img src="../assets/stamp/kiwotuke.png"></button>
                <audio ref="audioElm_kiwotuketene" src="../sound/kiwotuketene.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_gomenn"><img src="../assets/stamp/gomenn.png"></button>
                <audio ref="audioElm_gomenn" src="../sound/gomenn.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_genkidesuka"><img src="../assets/stamp/genkidesuka.png"></button>
                <audio ref="audioElm_genkidesuka" src="../sound/genkidesuka.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_konnitiha"><img src="../assets/stamp/konnitiha.png"></button>
                <audio ref="audioElm_konnitiha" src="../sound/konnitiha.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_konbanwa"><img src="../assets/stamp2/konbanwa.png"></button>
                <audio ref="audioElm_konnbanwa" src="../sound/konnbannwa.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button id="w"><img src="../assets/line/line_saw.png"></button>
              </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_sasuga"><img src="../assets/stamp2/sasuga.png"></button>
                <audio ref="audioElm_sasuga" src="../sound/sasuga.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_samui"><img src="../assets/stamp2/samui.png"></button>
                <audio ref="audioElm_samui" src="../sound/samui.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_sayonara"><img src="../assets/stamp/sayounara.png"></button>
                <audio ref="audioElm_sayonara" src="../sound/sayonara.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_sugoi"><img src="../assets/stamp/sugoi.png"></button>
                <audio ref="audioElm_sugoi" src="../sound/sugoi.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_sounannda"><img src="../assets/stamp2/sounanda.png"></button>
                <audio ref="audioElm_sounannda" src="../sound/sounannda.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button id="w"><img src="../assets/line/line_taw.png"></button>
              </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_daisuki"><img src="../assets/stamp/daisuki.png"></button>
                <audio ref="audioElm_daisuki" src="../sound/daisuki.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_daizyobu"><img src="../assets/stamp/daijoubu.png"></button>
                <audio ref="audioElm_daizyobu" src="../sound/daizyobu.mp3"></audio><br>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_daizyobu"><img src="../assets/stamp2/daizyoubu.png"></button>
                <audio ref="audioElm_daizyoubu" src="../sound/daizyobu.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_tadaima"><img src="../assets/stamp/tadaima.png"></button>
                <audio ref="audioElm_tadaima" src="../sound/tadaima.mp3"></audio>  
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_tanosii"><img src="../assets/stamp/tanosii.png"></button>
                <audio ref="audioElm_tanosii" src="../sound/tanosii.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_dame"><img src="../assets/stamp/dame.png"></button>
                <audio ref="audioElm_dame" src="../sound/dame.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_tegetege"><img src="../assets/stamp/tegetege.png"></button>
                <audio ref="audioElm_tegetege" src="../sound/tegetege.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_toire"><img src="../assets/stamp/toire.png"></button>
                <audio ref="audioElm_toire" src="../sound/toire.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_dousuru"><img src="../assets/stamp2/dousuru.png"></button>
                <audio ref="audioElm_dousuru" src="../sound/dousuru.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button id="w"><img src="../assets/line/line_naw.png"></button>
              </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_naisyo"><img src="../assets/stamp2/naisyo.png"></button>
                <audio ref="audioElm_naisyo" src="../sound/naisyo.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_nansai"><img src="../assets/stamp/nansai.png"></button>
                <audio ref="audioElm_nansai" src="../sound/nansai.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_naruhodo"><img src="../assets/stamp2/naruhodo.png"></button>
                <audio ref="audioElm_naruhodo" src="../sound/naruhodo.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_nemui"><img src="../assets/stamp/nemui.png"></button>
                <audio ref="audioElm_nemui" src="../sound/nemui.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_nodo"><img src="../assets/stamp2/nodo.png"></button>
                <audio ref="audioElm_nodo" src="../sound/nodo.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button id="w"><img src="../assets/line/line_haw.png"></button>
              </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_hisasiburi"><img src="../assets/stamp/hisasiburi.png"></button>
                <audio ref="audioElm_hisasiburi" src="../sound/hisasiburi.mp3"></audio><br>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_bikkuri"><img src="../assets/stamp/bikkuri.png"></button>
                <audio ref="audioElm_bikkuri" src="../sound/bikkurisita.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_pekori"><img src="../assets/stamp/pekori.png"></button>
                <audio ref="audioElm_pekori" src="../sound/pekori.mp3"></audio><br>
            </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button id="w"><img src="../assets/line/line_maw.png"></button>
              </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_makasete"><img src="../assets/stamp/makasete.png"></button>
                <audio ref="audioElm_makasete" src="../sound/makasete.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_matane"><img src="../assets/stamp2/matane.png"></button>
                <audio ref="audioElm_matane" src="../sound/matane.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_mattemasu"><img src="../assets/stamp/mattemasu.png"></button>
                <audio ref="audioElm_mattemasu" src="../sound/matteimasu.mp3"></audio><br>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_murisinai"><img src="../assets/stamp/murisinai.png"></button>
                <audio ref="audioElm_murisinai" src="../sound/murisinaidene.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button id="w"><img src="../assets/line/line_yaw.png"></button>
              </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_yatta"><img src="../assets/stamp/yatta.png"></button>
                <audio ref="audioElm_yatta" src="../sound/yatta---.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_yokattane"><img src="../assets/stamp/yokattane.png"></button>
                <audio ref="audioElm_yokattane" src="../sound/yokattane.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_yorosiku"><img src="../assets/stamp/yorosiku.png"></button>
                <audio ref="audioElm_yorosiku" src="../sound/yorosiku.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button id="w"><img src="../assets/line/line_raw.png"></button>
              </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button id="w"><img src="../assets/line/line_waw.png"></button>
              </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_wai"><img src="../assets/stamp2/wai.png"></button>
                <audio ref="audioElm_wai" src="../sound/wai.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_wakatta"><img src="../assets/stamp2/wakatta.png"></button>
                <audio ref="audioElm_wakatta" src="../sound/wakatta.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
                <div class="article-inside">
                <button v-on:click="addLast_wakuwaku"><img src="../assets/stamp/wakuwaku.png"></button>
                <audio ref="audioElm_wakuwaku" src="../sound/wakuwaku.mp3"></audio>
            </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button v-on:click="addLast_white"><img src="../assets2/stamp.png"></button>
              </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button v-on:click="addLast_white"><img src="../assets2/stamp.png"></button>
              </div>
            </article>
            <article class="article-item box">
              <div class="article-inside">
                <button v-on:click="addLast_white"><img src="../assets2/stamp.png"></button>
              </div>
            </article>
            </div>
        </div>
    </div>
</template>


<script>
import Loading from '@/components/Loading'
export default {
  name: 'Stamp',
  data () {
    return {
        loading: true,
    }
  },
    mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  components: {
    Loading,
  },
  methods: {
    addLast_sounannda: function () {
        this.$refs.audioElm_sounannda.play();
    },
    addLast_onakaippai: function () {
        this.$refs.audioElm_onakaippai.play();
    },
    addLast_wai: function () {
        this.$refs.audioElm_wai.play();
    },
    addLast_dousuru: function () {
        this.$refs.audioElm_dousuru.play();
    },
    addLast_wakatta: function () {
        this.$refs.audioElm_wakatta.play();
    },
    addLast_naisyo: function () {
        this.$refs.audioElm_naisyo.play();
    },
    addLast_ureshii: function () {
        this.$refs.audioElm_ureshii.play();
    },
    addLast_sasuga: function () {
        this.$refs.audioElm_sasuga.play();
    },
    addLast_samui: function () {
        this.$refs.audioElm_samui.play();
    },
    addLast_onegai: function () {
        this.$refs.audioElm_onegai.play();
    },
    addLast_matane: function () {
        this.$refs.audioElm_matane.play();
    },
    addLast_konbanwa: function () {
        this.$refs.audioElm_konnbanwa.play();
    },
    addLast_naruhodo: function () {
        this.$refs.audioElm_naruhodo.play();
    },
    addLast_nodo: function () {
        this.$refs.audioElm_nodo.play();
    },
    addLast_un: function () {
        this.$refs.audioElm_un.play();
    },



    addLast_konnitiha: function () {
        this.$refs.audioElm_konnitiha.play();
    },
    addLast_yorosiku: function () {
        this.$refs.audioElm_yorosiku.play();
    },
    addLast_okikunatta: function () {
        this.$refs.audioElm_okikunatta.play();
    },
    addLast_iine: function () {
        this.$refs.audioElm_iine.play();
    },
    addLast_tegetege: function () {
        this.$refs.audioElm_tegetege.play();
    },
    addLast_sugoi: function () {
        this.$refs.audioElm_sugoi.play();
    },
    addLast_gomenn: function () {
        this.$refs.audioElm_gomenn.play();
    },
    addLast_sayonara: function () {
        this.$refs.audioElm_sayonara.play();
    },
    addLast_nemui: function () {
        this.$refs.audioElm_nemui.play();
    },
    addLast_onakaitai: function () {
        this.$refs.audioElm_onakaitai.play();
    },
    addLast_atui: function () {
        this.$refs.audioElm_atui.play();
    },
    addLast_dame: function () {
        this.$refs.audioElm_dame.play();
    },
    addLast_itai: function () {
        this.$refs.audioElm_itai.play();
    },
    addLast_toire: function () {
        this.$refs.audioElm_toire.play();
    },
    addLast_tanosii: function () {
        this.$refs.audioElm_tanosii.play();
    },
    addLast_arigato: function () {
        this.$refs.audioElm_arigato.play();
    },
    addLast_ohayo: function () {
        this.$refs.audioElm_ohayo.play();
    },
    addLast_oyasumi: function () {
        this.$refs.audioElm_oyasumi.play();
    },
    addLast_okaeri: function () {
        this.$refs.audioElm_okaeri.play();
    },
    addLast_otukare: function () {
        this.$refs.audioElm_otukare.play();
    },
    addLast_omedeto: function () {
        this.$refs.audioElm_omedeto.play();
    },
    addLast_oishiine: function () {
        this.$refs.audioElm_oishiine.play();
    },
    addLast_ganbatte: function () {
        this.$refs.audioElm_ganbatte.play();
    },
    addLast_ganbaru: function () {
        this.$refs.audioElm_ganbaru.play();
    },
    addLast_genkidesuka: function () {
        this.$refs.audioElm_genkidesuka.play();
    },
    addLast_kiwotukete: function () {
        this.$refs.audioElm_kiwotuketene.play();
    },
    addLast_hisasiburi: function () {
        this.$refs.audioElm_hisasiburi.play();
    },
    addLast_bikkuri: function () {
        this.$refs.audioElm_bikkuri.play();
    },
    addLast_daisuki: function () {
        this.$refs.audioElm_daisuki.play();
    },
    addLast_daizyobu: function () {
        this.$refs.audioElm_daizyobu.play();
    },
    addLast_yatta: function () {
        this.$refs.audioElm_yatta.play();
    },
    addLast_wakuwaku: function () {
        this.$refs.audioElm_wakuwaku.play();
    },
    addLast_ittekimasu: function () {
        this.$refs.audioElm_ittekimasu.play();
    },
    addLast_itterassyai: function () {
        this.$refs.audioElm_itterassyai.play();
    },
    addLast_iiyo: function () {
        this.$refs.audioElm_iiyo.play();
    },
    addLast_ookiku: function () {
        this.$refs.audioElm_ookiku.play();
    },
    addLast_onakasuita: function () {
        this.$refs.audioElm_onakasuita.play();
    },
    addLast_pekori: function () {
        this.$refs.audioElm_pekori.play();
    },
    addLast_tadaima: function () {
        this.$refs.audioElm_tadaima.play();
    },
    addLast_nansai: function () {
        this.$refs.audioElm_nansai.play();
    },
    addLast_mattemasu: function () {
        this.$refs.audioElm_mattemasu.play();
    },
    addLast_murisinai: function () {
        this.$refs.audioElm_murisinai.play();
    },
    addLast_makasete: function () {
        this.$refs.audioElm_makasete.play();
    },
    addLast_yokattane: function () {
        this.$refs.audioElm_yokattane.play();
    },
  }
}
</script>

<style>
.content {
  margin: 0 auto;
  /* 外枠の大きさ */
  max-width: 880px;
  /* border: 1px solid black; */
  min-height: 600px;
}

/* 記事全ての枠の設定 */
.container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  /* 記事折り返し設定 */
  margin: 0px auto 80 auto 0px auto 80 auto;
}

.article-item {
  /* 記事アイテムの一つの大きさ */
  width: 16%;
  height: auto;
  margin-bottom: 0px;
  margin: 1% 0;
}

.article-item button img{
  /* 画像は親要素に対して100%にする */
  width: 100%;
  height: 100%;
}

.article-item p {
  padding: 0px 10px;
}


#text{
  background: white;
  height: 50px;
  font-size: 45px;
}

.single, text {
    background:linear-gradient(0, 0, 0);
}

.single{
    background-color: #ccddef;
}

.About{
    background-color: #ccddef;
}

table{
    width:100;
    text-align: left;
}
table th{
  padding: 12px;
  border-bottom: 2px solid darkgrey;
}
table tb{
    padding: 12px;
}
table tr:nth-of-type(even){
    background-color: rgba(0, 0, 255, 0.1);
}

button{
    outline: none;
    cursor: pointer;
    padding: 3px 3px;
    border-radius: 6px;
    color: #ccddef;
    border: 1px;
    background-color: #ccddef;
    transition: background-color .2s
}

button:hover{
    background-color: #ffffff;
}

button:active{
    background-color: #ffffff;
}

button:disabled{
    opacity: .5;
    pointer-events: none;
}
@font-face {
    font-family: minmoji;
    src: url('https://minmoji.ucda.jp/fontseot/https%3A__brushtalk-5c0f3.web.app_');
    src: local('minmoji'),
        url('https://minmoji.ucda.jp/fontswoff/https%3A__brushtalk-5c0f3.web.app_') format('woff'),
        url('https://minmoji.ucda.jp/fonts/https%3A__brushtalk-5c0f3.web.app_') format('opentype');
  }

  .stamp {
    font-family: minmoji;
  }
#w{
    background-color: #6B849E;
}
</style>